import { Location } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.scss"]
})
export class BackButtonComponent {
  /**
   * Telas com trabalho em andamento (ex.: emissão de NFS-e) precisam perguntar
   * algo antes de sair. Com `intercept`, o botão só emite `backClick` e quem
   * usa o componente decide quando chamar o voltar de fato.
   */
  @Input() intercept = false;
  @Output() backClick = new EventEmitter<void>();

  constructor(private location: Location) {}

  back() {
    if (this.intercept) {
      this.backClick.emit();
      return;
    }

    this.location.back();
  }
}
